import { Injectable } from '@angular/core';
import { HttpProviderService, HttpRequest, IHttpErrorPayload } from '@fpx/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RcobService {

  email: string = 'xxx****@xxxx.xxx';
  mobile: string = '+00 0** ***000';
  hideLivenessInfo: boolean = false;
  // offerCode: string = "0";
  // dedupeMatch: string = "2";

  private _obData:Map<string, any> = new Map<string, any>();
  private _styleClass:string = '';
  checkResendAttempt: boolean;
  applicationstatus: any;

  constructor(
    private _http: HttpProviderService,
    private _processShellService: ProcessShellService,
    private _commonService: CommonService
  ) { }

  continueOnBoarding(pCode: string, payload: any): Observable<any> {
    this._commonService.showSpinner();
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/retailcob');
    httpRequest.setMethod('POST');
    httpRequest.setBody(payload);
    httpRequest.setServerContext(environment.customersPublisher);

    return this._http.invokeRestApi(httpRequest).pipe(
      map((res) => {
        let _r = res.body?.retailcob;
        this._processShellService.processId = _r.processId;
        this._processShellService.processCode = _r.processCode || 'COB';
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
        this._commonService.hideSpinner();
        return res;
      }, catchError((err: IHttpErrorPayload) => {
        this._commonService.hideSpinner();
        return of(err);
      }))
    );
  }

  public isSameObject(object1: any, object2: any): boolean {
    let compareRes = true;
    for(let key of  Object.keys(object1)){
      try {
        if ((typeof(object1[key]) === 'string') && object1[key] != object2[key]) {
          compareRes = false; break
        }
        else if(Array.isArray(object1[key])) {
          object1[key].forEach((element,i) => {
            Object.keys(element).forEach(key2 => {
                try {
                  if(object2[key][i] && (element[key2] != object2[key][i][key2])) {
                    compareRes = false; return
                  }
                } catch (error) {
                  compareRes = false; return
                }
            });
          });
        }
        else if(typeof object1[key] === 'object') {
          compareRes = this.isSameObject(object1[key],object2[key]);
        }
      }
      catch (error) {
        compareRes = false; break
      }
    };
    return compareRes;
  }

  public setData(key: string, data:any){
    let _existingData = this._obData.get(key);
    if(_existingData){
      data = {
        ..._existingData,
        ...data
      }
    }
    this._obData.set(key, data);
  }

  public getData(key:string){
    return this._obData.get(key) || null;
  }

  public removeData(key:string){
    this._obData.delete(key);
  }

  public clearData(){
    this._obData.clear();
  }

  public setStyleClass(className:string){
    this._styleClass = className;
  }

  public removeStyleClass(){
    this._styleClass = '';
  }

  public getStyleClass():string{
    return this._styleClass || '';
  }

}
